<dsd-checkbox-group column="" (dsdCheckboxGroupChange)="onSelectionChange($event)">
  <span slot="legend">{{ 'caad.page-validation.comptes.libelle' | translate }}</span>
  <dsd-select-tile class="dsd-pl-0" checked [value]="compte" *ngFor="let compte of comptesTries">
    <span slot="label"
      ><strong>{{ compte.descriptionDivision }}</strong></span
    >
    <span slot="text">{{ compte.descriptionCompte }} - {{ compte.numeroCompte }}</span>
  </dsd-select-tile>
</dsd-checkbox-group>
